import { NavigationGuardNext, Route } from 'vue-router';
import { checkPermissions } from './routeValidation';
import { checkCommpixCredentials } from './commpixValidation';
import { checkMasspaymentCredentials } from './masspaymentValidation';
import store from '@/store';
import authType from '@/store/types/auth';
import { NemipayNotifications } from '@/util/nemipayNotifications';
import { validateCredentials } from '@/util/credentials';
import i18n from '@/i18n';

/**
 * Navigation guard that combines the validation of permissions and Commpix credentials
 * First validates permissions, then validates Commpix credentials if permissions pass
 */
export const checkPermissionsAndCommpixCredentials = (
  to: Route,
  from: Route,
  next: NavigationGuardNext<Vue>
): void => {
  // First, verify permissions
  checkPermissions(to, from, (result) => {
    if (typeof result === 'string' || (typeof result === 'object' && result?.name)) {
      // If checkPermissions redirects, do not continue
      next(result);
    } else {
      // If the permissions are fine, verify Commpix credentials
      checkCommpixCredentials(to, from, next);
    }
  });
};

export const checkPermissionsAndMasspaymentCredentials = (
  to: Route,
  from: Route,
  next: NavigationGuardNext<Vue>
): void => {
  // First, verify permissions
  checkPermissions(to, from, (result) => {
    if (typeof result === 'string' || (typeof result === 'object' && result?.name)) {
      // If checkPermissions redirects, do not continue
      next(result);
    } else {
      // If the permissions are fine, verify Masspayment credentials
      checkMasspaymentCredentials(to, from, next);
    }
  });
};

export const checkPermissionsAndCommpixOrMantecaCredentials = (
  to: Route,
  from: Route,
  next: NavigationGuardNext<Vue>
): void => {
  checkPermissions(to, from, (result) => {
    if (typeof result === 'string' || (typeof result === 'object' && result?.name)) {
      next(result);
    } else {
      const commpixCredentials = store.getters[`authModule/${authType.getters.GET_COMMPIX_CREDENTIALS}`];
      const mantecaCredentials = store.getters[`authModule/${authType.getters.GET_MANTECA_CREDENTIALS}`];
      const hasManteca = !!(
        mantecaCredentials?.userAnyId &&
        typeof mantecaCredentials.userAnyId === 'string' &&
        mantecaCredentials.userAnyId.trim() !== ''
      );

      if (!validateCredentials(commpixCredentials) && !hasManteca) {
        const notification = new NemipayNotifications();
        notification.warning(
          i18n.t('credentials.validation.commpixOrMantecaRequired') as string,
          i18n.t('credentials.validation.commpixOrMantecaRequiredMsg') as string
        );
        next(false);
        return;
      }

      next();
    }
  });
};
